import { t } from "@lingui/core/macro";
import { useAtomValue, useSetAtom } from "jotai";
import { lowerCase, startCase } from "lodash";
import { useMemo } from "react";

import { updateDiningOccasionTags } from "@/features/BookingWizard/DiningBookingWizard/atoms/actions/updateDiningOccasionTags/updateDiningOccasionTags";
import { getDiningOccasionTags } from "@/features/BookingWizard/DiningBookingWizard/atoms/selectors/getDiningOccasionTags/getDiningOccasionTags";
import { DiningBookingWizard } from "@/features/BookingWizard/DiningBookingWizard/types";
import { PillSelect } from "@whoosh/design-system/src/components/controls/PillSelect";
import { Text, VStack } from "@whoosh/design-system/src/components/primitive";

type Props = {
  options: DiningBookingWizard.DiningBookingWizardData["occasionTags"];
};

export const DiningWizardOccasionTagsControl = ({ options }: Props) => {
  const selectedOccasionTags = useAtomValue(getDiningOccasionTags);
  const setOccasionTags = useSetAtom(updateDiningOccasionTags);

  const pillOptions = useMemo(
    () =>
      options.map((option) => ({
        label: startCase(lowerCase(option)),
        value: option,
      })),
    [options]
  );

  return (
    <VStack gap={4} backgroundColor="surface-primary">
      <Text variant="mainBaseSemiBold">{t`Any special occasion?`}</Text>
      <PillSelect
        options={pillOptions}
        values={selectedOccasionTags}
        setValues={setOccasionTags}
        allowAddition={false}
        placeholder={t`Search occasion tags`}
      />
    </VStack>
  );
};
